import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class Filter {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      filterId: UUID.create(),
      name: '',
      columnId: '',
      dataType: '',
      type: 'EqualsTo',
      required: false,
      defaultValue: '',
      calculation: false,
      filterType: 'ordinary',
      placeholder: '',
      // 列宽
      width: 1,
      // 下拉框是否多选
      multipleChoice: false,
      // 筛选数据源
      dataSource: {
        enable: false,
        reportId: '',
        columnId: '',
        showColumnId: '',
        remote: false
      },
      template: {
        enable: true,
        stringOptions: ''
      },
      // 更多模式
      moreType: '',
      // 实时搜索
      immediate: false
    }
    if (typeof (args.position) === 'string') {
      args.position = JSON.parse(args.position)
    }
    if (typeof (args.dataSource) === 'string') {
      args.dataSource = JSON.parse(args.dataSource)
    }
    if (typeof (args.template) === 'string') {
      args.template = JSON.parse(args.template)
    }

    _.defaults(this, args, defaults)
  }

  static create (args, position) {
    let param = {
      'columnId': args.id,
      'dataType': args.columnType,
      'position': position
    }
    return new Filter(param)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/filter.js